export default __webpack_public_path__ + "static/media/BOB_0078.ac3a10f8.JPG";